document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('brand-list-root');
  const rootPreloader = root.querySelector('p');
  if (!root) return;

  const domain = root.dataset.domain;
  const token = root.dataset.token;
  const metafieldNamespace = root.dataset.brandMetafieldNamespace;
  const metafieldKey = root.dataset.brandMetafieldKey;

  if (!domain || !token) {
    rootPreloader.textContent = 'Storefront API error.';
    return;
  }

  const endpoint = `https://${domain}/api/2024-07/graphql.json`;

  const query = `
    query CollectionsWithBrands($cursor: String) {
      collections(first: 200, after: $cursor) {
        edges {
          cursor
          node {
            id
            handle
            title
            onlineStoreUrl
            metafield(namespace: "${metafieldNamespace}", key: "${metafieldKey}") {
              value
              type
            }
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `;

  async function fetchAllCollections() {
    let cursor = null;
    let hasNextPage = true;
    const all = [];

    while (hasNextPage) {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
          query,
          variables: { cursor },
        }),
      });

      if (!res.ok) throw new Error('Storefront API error: ' + res.status);

      const json = await res.json();
      if (json.errors) throw new Error('GraphQL errors');

      const data = json.data.collections;
      data.edges.forEach(edge => {
        all.push(edge.node);
        cursor = edge.cursor;
      });

      hasNextPage = data.pageInfo.hasNextPage;
    }

    return all;
  }

  function isBrandCollection(col) {
    if (!col.metafield) return false;
    const val = col.metafield.value;
    return val === 'true' || val === '1' || val === 1;
  }

  function sortByTitle(a, b) {
    return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
  }

  function buildHtml(brands) {
    const columnCount = 5;
    let html = '';
    let currentLetter = '';
    let localList = [];

    function flushLetter() {
      if (!localList.length) return;

      const firstLetter = currentLetter;
      const columns = Array.from({ length: columnCount }, () => []);

      localList.forEach((item, i) => {
        const colIndex = i % columnCount;
        columns[colIndex].push(item);
      });

      html += `
        <div class="brand-segment">
          <div class="brand-segment-header" data-target="ancor-for-${firstLetter.toLowerCase()}">
            <span>${firstLetter}</span>
          </div>
          <div class="columns-container js-special-grouping" data-init="true">
      `;

      columns.forEach(colItems => {
        html += `<ul>`;
        colItems.forEach(col => {
          const url = col.onlineStoreUrl || `/collections/${col.handle}`;
          html += `<li><a style="white-space: nowrap" href="${url}">${col.title}</a></li>`;
        });
        html += `</ul>`;
      });

      html += `
          </div>
        </div>
      `;

      localList = [];
    }

    brands.forEach(col => {
      const firstLetter = (col.title || '').slice(0, 1).toUpperCase();

      if (firstLetter !== currentLetter) {
        flushLetter();
        currentLetter = firstLetter;
      }

      localList.push(col);
    });

    flushLetter();

    return html;
  }

  async function init() {
    try {
      rootPreloader.textContent = 'Loading...';

      const allCollections = await fetchAllCollections();
      const brandCollections = allCollections
        .filter(isBrandCollection)
        .sort(sortByTitle);

      if (!brandCollections.length) {
        rootPreloader.textContent = 'Brands not found.';
        return;
      }

      root.innerHTML = buildHtml(brandCollections);
      document.dispatchEvent(new Event('brands-ready'));

    } catch {
      rootPreloader.textContent = 'Loading Error.';
    }
  }

  init();
});
